<template>
  <v-dialog v-model="dialog" persistent width="1500">
    <common-card>
      <v-card-text class="pa-4 black--text">
        <div
          class="pt-5 pb-5 top-text"
          style="width: 100%; justify-content: center; text-align: center"
        >
          {{ isNew ? "Nuevo recordatorio" : "Editar recordatorio" }}
        </div>

        <div class="pt-5 pb-5">
          <commond-form
            :request="request"
            :route="route"
            :action="action"
            :run="validate"
            @cancel="validate = false"
            @success="$emit('success')"
            @afterError="afterError"
          >
            <template v-slot:data>
              <v-row>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    label="Estatus"
                    outlined
                    :items="statusItems"
                    item-text="text"
                    item-value="value"
                    v-model="request.status"
                    color="#00a7e4"
                    :rules="requiredRule"
                    :disabled="isNew"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <v-autocomplete
                    label="Ramo"
                    outlined
                    :items="ramosInbound"
                    v-model="request.ramo"
                    color="#00a7e4"
                    :rules="requiredRule"
                    :disabled="!isNew"
                    clearable
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <v-autocomplete
                    label="Producto"
                    outlined
                    :items="productosInbound"
                    item-text="producto"
                    item-value="producto"
                    v-model="request.producto"
                    color="#00a7e4"
                    :rules="requiredRule"
                    :disabled="!isNew || !request.ramo"
                    clearable
                  />
                </v-col>

                <!-- <v-col cols="12" md="3">
                  <v-autocomplete
                    label="Empresa"
                    outlined
                    :items="empresasInbound"
                    item-text="empresa"
                    item-value="empresa"
                    v-model="request.empresa"
                    color="#00a7e4"
                    :rules="requiredRule"
                    :disabled="!isNew || !request.producto"
                    clearable
                  />
                </v-col> -->
                <v-col cols="12" md="3">
                  <v-autocomplete
                    label="Empresas"
                    outlined
                    :items="empresasInbound"
                    item-text="empresa"
                    item-value="empresa"
                    v-model="empresasSeleccionadas"
                    color="#00a7e4"
                    :rules="requiredRule"
                    :disabled="!isNew || !request.producto"
                    multiple
                    clearable
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 2" small>
                        {{ item.empresa || item }}
                      </v-chip>
                      <span v-if="index === 2" class="grey--text text-caption">
                        +{{ empresasSeleccionadas.length - 2 }}
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field
                    label="Nombre recordatorio"
                    outlined
                    v-model.trim="request.nombre"
                    color="#00a7e4"
                    :rules="requiredRule"
                    clearable
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <v-autocomplete
                    label="Correo Saliente"
                    outlined
                    :items="correosSalientes"
                    item-text="cuenta"
                    item-value="cuenta"
                    v-model="request.correo"
                    color="#00a7e4"
                    :rules="requiredRule"
                    :disabled="!isNew"
                    clearable
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field
                    label="Intentos de recordatorio"
                    outlined
                    v-model.number="request.intentos_recordatorio_info"
                    color="#00a7e4"
                    type="number"
                    :rules="requiredRule"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field
                    label="Periodicidad por día"
                    outlined
                    v-model.number="request.periodicidad_por_dia"
                    color="#00a7e4"
                    type="number"
                    :rules="requiredRule"
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <v-autocomplete
                    label="Recordatorio Pendiente Información"
                    outlined
                    :items="plantillasActivas"
                    item-text="nombre"
                    item-value="id"
                    v-model="request.template_recordatorio_info"
                    color="#00a7e4"
                    :rules="requiredRule"
                    clearable
                  />
                </v-col>

                <v-col cols="12" md="3">
                  <v-autocomplete
                    label="Recordatorio Cierre"
                    outlined
                    :items="plantillasActivas"
                    item-text="nombre"
                    item-value="id"
                    v-model="request.template_recordatorio_cierre"
                    color="#00a7e4"
                    :rules="requiredRule"
                    clearable
                  />
                </v-col>
              </v-row>
            </template>
          </commond-form>
        </div>

        <div>
          <v-row style="text-align: end">
            <v-col cols="12">
              <v-btn
                text
                color="#00a7e4"
                outlined
                dark
                style="border-radius: 15px"
                @click="$emit('closeModal')"
              >
                Cancelar
              </v-btn>

              <v-btn class="common-botton" dark @click="run = true">
                {{ isNew ? "Guardar" : "Editar" }}
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </common-card>
  </v-dialog>
</template>

<script>
import CommonCard from "../CommonCard.vue";

import { getEmpresasInbound } from "@/services/empresasInbound/EmpresasInbound.js";
import { getCuentasCorreoListByParams } from "@/services/cuentasCorreo/cuentasCorreo.service.js";
import { getPlantillasEciList } from "@/services/plantillasECI/plantillaECI.service.js";

export default {
  components: {
    CommonCard,
    CommondForm: () => import("@/components/commonComponents/CommondForm.vue"),
  },

  props: {
    dialog: Boolean,
    isNew: { type: Boolean, default: true },
    selected: { type: Object, default: null },
  },

  data() {
    return {
      request: {
        status: 2,
        nombre: "",
        ramo: "",
        producto: null,
        empresas: [],
        correo: "",
        intentos_recordatorio_info: null,
        periodicidad_por_dia: null,
        template_recordatorio_info: null,
        template_recordatorio_cierre: null,
      },

      statusItems: [
        { text: "Activo", value: 1 },
        { text: "Inactivo", value: 2 },
      ],

      requiredRule: [
        (v) =>
          (v !== null && v !== undefined && String(v).trim() !== "") ||
          "El campo es requerido",
      ],

      run: false,
      validate: false,
      route: "",
      action: "POST",

      // combos
      empresasInboundRaw: [],
      ramosInbound: [],
      productosInbound: [],
      empresasInbound: [],
      empresasSeleccionadas: [],
      correosSalientes: [],
      plantillasActivas: [],
    };
  },

  watch: {
    run(val) {
      if (val) {
        // Construir empresas con correo justo antes de enviar
        this.request.empresas = this.empresasSeleccionadas.map((nombre) => ({
          empresa: nombre,
        }));
      }
      this.validate = !!val;
    },

    // Encadenado creación
    "request.ramo"(val) {
      if (!this.isNew) return;

      this.request.producto = null;
      this.empresasSeleccionadas = [];
      this.empresasInbound = [];
      this.productosInbound = [];

      if (!val) return;

      const productos = this.empresasInboundRaw
        .filter((x) => x.ramo === val)
        .map((x) => x.producto);

      this.productosInbound = [...new Set(productos)]
        .filter(Boolean)
        .sort()
        .map((p) => ({ producto: p }));
    },

    "request.producto"(val) {
      if (!this.isNew) return;

      this.empresasSeleccionadas = [];
      this.empresasInbound = [];

      if (!val) return;

      const empresas = this.empresasInboundRaw
        .filter((x) => x.ramo === this.request.ramo && x.producto === val)
        .map((x) => x.empresa);

      this.empresasInbound = [...new Set(empresas)]
        .filter(Boolean)
        .sort()
        .map((e) => ({ empresa: e }));
    },

    empresasSeleccionadas(val) {
      this.request.empresas = val.map((nombre) => ({
        empresa: nombre,
      }));
    },
  },

  methods: {
    afterError() {
      this.$emit("closeModal");
      this.run = false;
      this.validate = false;
    },

    setupMode() {
      if (this.isNew) {
        this.action = "POST";
        this.route = "/v1/recordatorio/insert";
        this.request.status = 2;
        this.request.nombre = "";
      } else {
        this.action = "PUT";
        const id =
          this.selected?.id ||
          this.selected?.recordatorio_id ||
          this.selected?.recordatorioId;

        this.route = `/v1/recordatorio/update/${id}`;

        Object.assign(this.request, {
          status: this.selected?.status ?? 1,
          nombre: this.selected?.nombre ?? "",
          ramo: this.selected?.ramo ?? "",
          producto: this.selected?.producto ?? null,
          empresas: this.selected?.empresas ?? [],
          correo: this.selected?.correo ?? "",
          intentos_recordatorio_info:
            this.selected?.intentos_recordatorio_info ?? null,
          periodicidad_por_dia: this.selected?.periodicidad_por_dia ?? null,
          template_recordatorio_info:
            this.selected?.template_recordatorio_info ?? null,
          template_recordatorio_cierre:
            this.selected?.template_recordatorio_cierre ?? null,
        });
        this.empresasSeleccionadas = (this.selected?.empresas ?? []).map(
          (e) => e.empresa,
        );
      }
    },

    async loadEmpresasInbound() {
      const resp = await getEmpresasInbound();
      this.empresasInboundRaw = resp?.data?.empresas ?? [];

      const ramos = this.empresasInboundRaw.map((x) => x.ramo);
      this.ramosInbound = [...new Set(ramos)].filter(Boolean).sort();
    },

    async loadCorreosSalientes() {
      try {
        const resp = await getCuentasCorreoListByParams({
          status: 1,
        });

        const cuentas =
          resp?.data?.cuentas ||
          resp?.data?.cuentas_correo ||
          resp?.cuentas ||
          resp?.data ||
          [];

        const list = cuentas.items || cuentas.cuentas || cuentas || [];

        this.correosSalientes = Array.isArray(list) ? list : [];
      } catch (e) {
        this.correosSalientes = [];
        this.$toast?.error?.(
          e?.message || "No se pudieron cargar correos salientes",
        );
      }
    },

    async loadPlantillasActivas() {
      try {
        const resp = await getPlantillasEciList({
          status: 1,
          pagina: 1,
          elementosPagina: 1000,
        });

        const list = resp?.data?.plantillas ?? [];

        // normaliza a lo que espera el autocomplete: {id, nombre}
        this.plantillasActivas = list
          .filter((x) => x.statusId === 1 || x.status === "Activa") // por si llega con texto
          .map((x) => ({
            id: x.id,
            nombre: x.nombre,
          }))
          .filter((x) => x.id != null && x.nombre)
          .sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""));
      } catch (e) {
        this.plantillasActivas = [];
        this.$toast?.error?.(
          e?.message || "No se pudieron cargar plantillas ECI",
        );
      }
    },
  },

  async mounted() {
    this.setupMode();

    await this.loadEmpresasInbound();
    await this.loadCorreosSalientes();
    await this.loadPlantillasActivas();

    if (!this.isNew) {
      const productos = this.empresasInboundRaw
        .filter((x) => x.ramo === this.request.ramo)
        .map((x) => x.producto);

      this.productosInbound = [...new Set(productos)]
        .filter(Boolean)
        .sort()
        .map((p) => ({ producto: p }));

      const empresas = this.empresasInboundRaw
        .filter(
          (x) =>
            x.ramo === this.request.ramo &&
            x.producto === this.request.producto,
        )
        .map((x) => x.empresa);

      this.empresasInbound = [...new Set(empresas)]
        .filter(Boolean)
        .sort()
        .map((e) => ({ empresa: e }));
    }
  },
};
</script>

<style scoped>
.top-text {
  height: 22px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 110%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #4d5358;
}
</style>
